import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OptionInterface } from '../../../../core/models/option.interface';

/**
 * Multiselection over the project's standard field API. Same wrapper as
 * `app-autocomplete-field` but with `multiple`, so the form control holds an
 * array of values: with `bindValue` the selection travels inside
 * `form.getRawValue()` and the `formChanged` validator picks it up on its own.
 */
@Component({
  selector: 'app-multiselect-field',
  templateUrl: './multiselect-field.component.html',
  styleUrls: ['./multiselect-field.component.css']
})
export class MultiselectFieldComponent {
  @Input() id: string;
  @Input() controlName: string;
  @Input() key: string;
  @Input() form: FormGroup;
  @Input() options: OptionInterface[];
  @Input() class = 'field';
  @Input() allowClear = false;
  @Input() notFoundText = 'shared.autocomplete.notFound';
  @Input() placeholder: string;
  @Input() hideLabel = false;
  @Input() hideErrors = false;
  @Output() change = new EventEmitter<any>();
  @ViewChild('error') error;
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/multiselect-field/multiselect-field.component.ts